<template>
    <div class="performance">
        <Swiper class="theme_img" v-if="imagePath.length > 0"    duration="1000" >
            <Slide v-for="(item,index) in imagePath" :key="index">
                <img :src="weburl+item" alt="">
            </Slide>
        </Swiper>

            <div  v-for="(n, i) in performanceImgLists" :key="i" @click="PerformanceShow(i)">
                <img :src="n" alt=""></div>
            <!--<div @click="PerformanceShow(2)">
                <img src="../../assets/images/performance/performance_2.jpg" alt=""></div>
            <div @click="PerformanceShow(3)">
                <img src="../../assets/images/performance/performance_3.jpg" alt=""></div>
            <div @click="PerformanceShow(4)">
                <img src="../../assets/images/performance/performance_4.jpg" alt=""></div>
            <div @click="PerformanceShow(5)">
                <img src="../../assets/images/performance/performance_5.jpg" alt=""></div>
            <div @click="PerformanceShow(6)">
                <img src="../../assets/images/performance/performance_6.jpg" alt=""></div>-->
    </div>
</template>

<script>
    import { Swiper, Slide } from 'vue-swiper-component';
    export default {
        name: "performance",
        components:{
            Swiper,
            Slide
        },
        data:function(){
            return {
                imagePath: [],
                perform_content:'',
                performanceImgLists:[
                    require('../../assets/images/performance/performance_1.jpg'),
                    require('../../assets/images/performance/performance_2.jpg'),
                    require('../../assets/images/performance/performance_3.jpg'),
                    require('../../assets/images/performance/performance_4.jpg'),
                    require('../../assets/images/performance/performance_5.jpg'),
                    require('../../assets/images/performance/performance_6.jpg')
                ]
            }
        },
        created(){
            this.carousel();
            this.$store.commit("set_current", 4);
            this.$store.commit("set_title", 'nav.performance');
            this.changeLang();
        },
        methods: {
            changeLang(){
                if(this.$i18n.locale !== "zh"){
                    switch (this.$i18n.locale) {
                        case "en":
                            this.performanceImgLists = [
                                    require('../../assets/images/lang/en/performance01.jpg'),
                                    require('../../assets/images/lang/en/performance02.jpg'),
                                    require('../../assets/images/lang/en/performance03.jpg'),
                                    require('../../assets/images/lang/en/performance04.jpg'),
                                    require('../../assets/images/lang/en/performance05.jpg'),
                                    require('../../assets/images/lang/en/performance06.jpg'),
                                ];
                            break;
                        case "kor":
                            this.performanceImgLists = [
                                require('../../assets/images/lang/kor/performance01.jpg'),
                                require('../../assets/images/lang/kor/performance02.jpg'),
                                require('../../assets/images/lang/kor/performance03.jpg'),
                                require('../../assets/images/lang/kor/performance04.jpg'),
                                require('../../assets/images/lang/kor/performance05.jpg'),
                                require('../../assets/images/lang/kor/performance06.jpg'),
                            ];
                            break;
                        case  "jap":
                            this.performanceImgLists = [
                                require('../../assets/images/lang/jap/performance01.jpg'),
                                require('../../assets/images/lang/jap/performance02.jpg'),
                                require('../../assets/images/lang/jap/performance03.jpg'),
                                require('../../assets/images/lang/jap/performance04.jpg'),
                                require('../../assets/images/lang/jap/performance05.jpg'),
                                require('../../assets/images/lang/jap/performance06.jpg'),
                            ];
                            break;


                    }
                }
            },
            PerformanceShow (i) {
                //    获取数据的方法
                let id = parseInt(i) + 1;
                this.$router.push({path: `/performanceDetail/${id}`});
               /* this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/Perform/getPerform",
                    dataType: "json",
                    data: {
                        perform_id: i
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.$store.commit("set_performance_list", res.data.result);
                            // console.log(res.data.result);
                            this.perform_content =  res.data.result;
                            if (this.$store.state.show.performance_list) {

                               //如果本地仓库中有值才让他跳转路由
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })*/
            },
            carousel(){
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/Perform/getPerform",
                    dataType: "json",
                    data: {
                        perform_id: 1
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                          this.imagePath =res.data.result.mobile_url.filter(item=>item);

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        },
        computed: {
            //计算属性，
            performance_list: function () {
                //先用变量接住我们存储在vuex里面的数据，
                return this.$store.state.show.performance_list;
            },
            weburl: function () {
                return this.$store.state.weburl;
            }

        },

    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common';
    .performance {
        width: @width;
        .theme_img {
            width: @width;
            /*height: 210px;*/
            img {
                .img;
            }
        }
       img{
             display: block;
             width: @width;
           vertical-align: bottom;
         }
    }



</style>
